import httpClientPlugin from '@/plugins/httpClientPlugin';

const useHttpClient = () => httpClientPlugin();

export default useHttpClient;
